import { Heart } from 'lucide-react'
import { track } from '../lib/analytics'

/**
 * Slim site footer carrying the Ko-fi tip link.
 *
 * Deliberately quiet. The subscribe CTA is the valuable action on this page - a
 * subscriber compounds into sponsor inventory, a tip happens once - so this sits
 * below the fold-level content and never competes with it. It's a link, not a
 * button, for the same reason.
 *
 * Copy avoids "keep it free": LYH Events is positioned as sponsor-supported, and
 * leaning on "free" as the value prop boxes in a future premium tier and
 * undercuts the local-media framing the ad rates are sold against.
 */
export function SiteFooter() {
  const kofi = (
    <a
      href="https://ko-fi.com/lyhevents"
      target="_blank"
      rel="noopener noreferrer"
      onClick={() => track('kofi_clicked', { from: 'calendar_footer' })}
      className="inline-flex items-center gap-1 font-medium text-slate-700 underline underline-offset-2 hover:text-brick-600 dark:text-slate-300 dark:hover:text-brick-300"
    >
      <Heart className="h-3 w-3" />
      Ko-Fi
    </a>
  )

  // The disaster-resources link used to sit here. It moved into the top bar's
  // menu on 2026-09-07 (Andrew): the reasoning for putting it in the footer was
  // that it should not compete for attention on a normal day, which held, but on
  // a phone it meant scrolling the entire calendar to reach a page you need on a
  // bad one. The menu keeps it quiet AND one tap from anywhere.

  return (
    <footer className="shrink-0 border-t border-hairline px-3 py-1.5 text-center dark:border-slate-800">
      {/* Phones drop this line entirely (Andrew, 2026-09-07: "remove the 'put
          together locally' sentence since the icon is there"). The bottom tab bar
          carries Donate on a phone, so the sentence was asking twice on the one
          screen where the footer costs the most.

          Desktop keeps it, and this is the one place the instruction did not
          reach: the tab bar is md:hidden, so removing this there would leave the
          site with no Ko-fi link at all above md. Say the word and it goes from
          both. */}
      <p className="hidden text-xs text-slate-600 sm:block dark:text-slate-400">
        Put together locally. If it&apos;s useful to you, you can support it on{' '}
        {kofi}.
      </p>

      {/* Times and prices come from venue posts and reader submissions, and both
          change after we read them. Say so once, quietly, rather than letting
          someone drive out to a cancelled event assuming we knew.

          "Quietly" means small and last, not faint. Both lines were slate-400 on
          paper, 2.49:1, and PageSpeed failed them (2026-09-23). They are
          slate-600 now, 7.18:1, and the Ko-fi sentence above moved from
          slate-500 (4.51:1, AA by a hundredth) to match, so the disclaimer never
          reads louder than the line beside it. The Ko-fi link itself stays
          slate-700 medium and underlined, so it still leads the footer. */}
      <p className="mt-0.5 text-xs text-slate-600 sm:hidden dark:text-slate-500">
        We recommend confirming event details with hosts.
      </p>
      <p className="mt-0.5 hidden text-xs text-slate-600 sm:block dark:text-slate-500">
        We try to get every listing right, but for the best experience we recommend you
        confirm details with the host before you attend.
      </p>


    </footer>
  )
}
